import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  title: {
    id: 'singlePayerPayment.payementSuccessful.title',
    defaultMessage: 'Your payment has been successfully submitted!',
  },
  instructions: {
    id: 'singlePayerPayment.payementSuccessful.instructions',
    defaultMessage: 'You will receive a receipt sent to the email address you provided.',
  },
  alreadySubmitted: {
    id: 'singlePayerPayment.payementSuccessful.alreadySubmitted',
    defaultMessage: 'This payment has already been submitted.',
  },
  contactSupport: {
    id: 'singlePayerPayment.payementSuccessful.contactSupport',
    defaultMessage: 'If you have questions, contact info@keytravel.com or {merchantName}'
  },
});



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/payment-successful.i18n.js